<template>
   <div class="checkout-ssrs-wrapper" :id="`checkout-ssrs-${flightIdentifier}`">
      <div class="checkout-ssrs-container">
         <!-- Passenger Info Column (Fixed Left) -->
         <div class="checkout-ssr-paxes-wrapper">
            <!-- Empty Header Space -->
            <div class="pax-header-space"></div>

            <!-- Passenger Rows -->
            <div class="pax-info-body">
               <div class="pax-info-cell" v-for="(pax, paxIndex) in SSRs.paxes" :key="paxIndex">
                  <div class="passenger-info">
                     <span class="passenger-name">{{ pax.label }}</span>
                     <span class="passenger-type">{{ pax.type }}</span>
                  </div>
                  <div class="segments">
                     <div class="segment-route" v-for="(segment, segmentIndex) in pax.segments" :key="segmentIndex">
                        <span class="route-from">{{ segment.departureAirportCode }}</span>
                        <img :src="`https://cdn.dev.reisetech.io/airline_34x34/${segment.airlineCode}.svg`" alt="" class="route-airline" />
                        <span class="route-to">{{ segment.arrivalAirportCode }}</span>
                     </div>
                  </div>
               </div>
            </div>

            <!-- Total Footer -->
            <div class="pax-footer-space">
               <div class="total-label-wrapper">
                  <span>{{ $t("CheckoutSSRs_lblTotal") }}</span>
                  <!-- <i
                     :class="['gts-icon', showSegmentBreakdown ? 'icon-eye' : 'icon-eye-closed']"
                     @click="showSegmentBreakdown = !showSegmentBreakdown"
                     :title="showSegmentBreakdown ? $t('CheckoutSSRs_lblShowTotal') : $t('CheckoutSSRs_lblShowBySegment')"></i> -->
               </div>

               <!-- Segment Routes (when breakdown is enabled) -->
               <div class="segment-routes" v-if="showSegmentBreakdown">
                  <div class="segment-route-item" v-for="(segment, segmentIndex) in SSRs.paxes[0].segments" :key="segmentIndex">
                     <span class="route-from">{{ segment.departureAirportCode }}</span>
                     <img :src="`https://cdn.dev.reisetech.io/airline_34x34/${segment.airlineCode}.svg`" alt="" class="route-airline" />
                     <span class="route-to">{{ segment.arrivalAirportCode }}</span>
                  </div>
               </div>
            </div>
         </div>

         <!-- SSR Carousel -->
         <div class="checkout-ssrs-carousel">
            <!-- Left Arrow -->
            <button class="nav-arrow nav-left" :disabled="!canScrollLeft" @click="scrollLeft">
               <i class="gts-icon icon-arrow-left icon-xs"></i>
            </button>

            <!-- SSR Columns Container -->
            <div class="columns-wrapper" :style="{ width: wrapperWidth }">
               <div class="columns-container" :style="{ transform: `translateX(-${translateX}px)` }">
                  <div class="ssr-column" v-for="(column, colIndex) in SSRs.columns" :key="column.identifier">
                     <!-- Header -->
                     <div
                        class="column-header"
                        :class="{
                           'is-odd': colIndex % 2 === 0,
                           'is-even': colIndex % 2 !== 0,
                           'hover-remove': hoverColumn[column.identifier],
                        }"
                        @mouseenter="setHoverColumn(column.identifier)"
                        @mouseleave="clearHoverColumn(column.identifier)"
                        @click="clearColumn(column.identifier, flightIdentifier)">
                        <img :src="require(`@/assets/images/checkoutSsrs/light/${column.identifier}.png`)" alt="" class="light-mode-ssr-image" :class="column.identifier" />
                        <img :src="require(`@/assets/images/checkoutSsrs/dark/${column.identifier}.png`)" alt="" class="dark-mode-ssr-image" />
                        <span class="ssr-header-remove"></span>
                        <span class="ssr-header-name">{{ $t(`CheckoutSSRs_lbl${column.label}`) }}</span>
                     </div>

                     <!-- Body: Passenger rows -->
                     <div class="column-body">
                        <div class="pax-cell" v-for="(pax, paxIndex) in SSRs.paxes" :key="paxIndex">
                           <div class="segment-cell" v-for="(segment, segmentIndex) in pax.segments" :key="segmentIndex">
                              <template v-if="segment.ssrs[column.identifier]">
                                 <div class="ssr-item">
                                    <!-- Selected State -->
                                    <template v-if="segment.ssrs[column.identifier].selected">
                                       <button
                                          class="ssr-button has-selection"
                                          :class="{
                                             'in-basket': segment.ssrs[column.identifier].inBasket,
                                             'free-conjuncted': segment.ssrs[column.identifier].isFreeConjuncted,
                                             'remove-preview': segment.ssrs[column.identifier].isFreeConjuncted && isConjunctedHovered(pax.id, column.identifier),
                                          }"
                                          @click="
                                             segment.ssrs[column.identifier].isFreeConjuncted
                                                ? null
                                                : clearSSR(segment.ssrs[column.identifier], column.identifier, pax.id, segmentIndex + 1, flightIdentifier)
                                          "
                                          @mouseenter="
                                             !segment.ssrs[column.identifier].isFreeConjuncted && segment.ssrs[column.identifier].isConjunctedMaster ? setHoverRemove(pax.id, column.identifier) : null
                                          "
                                          @mouseleave="
                                             !segment.ssrs[column.identifier].isFreeConjuncted && segment.ssrs[column.identifier].isConjunctedMaster
                                                ? clearHoverRemove(pax.id, column.identifier)
                                                : null
                                          "
                                          :disabled="segment.ssrs[column.identifier].isFreeConjuncted">
                                          <span v-if="segment.ssrs[column.identifier].name" class="ssr-name">{{ segment.ssrs[column.identifier].description }}</span>
                                          <template v-if="!segment.ssrs[column.identifier].isFreeConjuncted && typeof segment.ssrs[column.identifier].price == 'number'">
                                             <span class="ssr-price" v-if="segment.ssrs[column.identifier].price == 0">{{ $t("CheckoutSSRs_lblFree") }}</span>
                                             <span class="ssr-price" v-else>{{ segment.ssrs[column.identifier].price | price }}</span>
                                          </template>
                                          <span v-if="segment.ssrs[column.identifier].isFreeConjuncted" class="ssr-free-label">{{ $t("CheckoutSSRs_lblFree") }}</span>
                                          <span v-else class="ssr-close"></span>
                                       </button>
                                    </template>

                                    <!-- Empty State -->
                                    <template v-else>
                                       <button
                                          class="ssr-button"
                                          :class="{
                                             'making-selection':
                                                activeDropdown && activeDropdown.paxIndex === paxIndex && activeDropdown.segmentIndex === segmentIndex && activeDropdown.colIndex === colIndex,
                                             'is-mandatory': segment.ssrs[column.identifier].isMandatory,
                                             'is-conjucted': segment.ssrs[column.identifier].isConjuncted,
                                             'btn-disabled': segment.ssrs[column.identifier].options.length == 0,
                                          }"
                                          @click.stop="
                                             segment.ssrs[column.identifier].options.length > 0
                                                ? openDropdown($event, paxIndex, segmentIndex, colIndex, column.identifier, segment.ssrs[column.identifier].options, segment.ssrs[column.identifier])
                                                : null
                                          ">
                                          <template v-if="!segment.ssrs[column.identifier].isConjuncted && segment.ssrs[column.identifier].options.length != 0">
                                             <span class="ssr-add"></span>
                                             <span v-if="segment.ssrs[column.identifier].isMandatory" class="ssr-mandatory-label">({{ $t("CheckoutSSRs_lblMandatory") }})</span>
                                          </template>
                                       </button>
                                    </template>
                                 </div>
                              </template>
                           </div>
                        </div>
                     </div>

                     <!-- Footer: Total -->
                     <div class="column-footer">
                        <!-- Combined Total -->
                        <template v-if="!showSegmentBreakdown">
                           <template v-if="combinedTotals[column.identifier]?.count > 0">
                              <span class="total-price">{{ combinedTotals[column.identifier].price | price }}</span>
                           </template>
                           <template v-else>
                              <span class="total-empty">-</span>
                           </template>
                        </template>

                        <!-- Segment Breakdown -->
                        <template v-else>
                           <div class="segment-breakdown">
                              <div class="segment-total" v-for="(segment, segmentIndex) in SSRs.paxes[0].segments" :key="segmentIndex">
                                 <template v-if="ssrTotals[`${column.identifier}_${segmentIndex + 1}`]?.count > 0">
                                    <span class="total-price">{{ ssrTotals[`${column.identifier}_${segmentIndex + 1}`].price | price }}</span>
                                 </template>
                                 <template v-else>
                                    <span class="total-empty">-</span>
                                 </template>
                              </div>
                           </div>
                        </template>
                     </div>
                  </div>
               </div>
            </div>

            <!-- Right Arrow -->
            <button class="nav-arrow nav-right" :disabled="!canScrollRight" @click="scrollRight">
               <i class="gts-icon icon-arrow-right icon-xs"></i>
            </button>

            <!-- Global Dropdown (Outside columns-wrapper) -->
            <ul
               v-if="activeDropdown"
               v-click-outside="closeDropdown"
               class="ssr-dropdown ssr-dropdown-global"
               :class="{
                  'dropdown-up': activeDropdown.paxIndex === SSRs.paxes.length - 1,
               }"
               :style="{
                  top: dropdownPosition.top + 'px',
                  left: dropdownPosition.left + 'px',
               }">
               <li v-for="(option, optionIndex) in activeDropdown.options" :key="optionIndex" @click="selectSSRFromGlobalDropdown(option)">
                  <div class="option-info">
                     <span class="option-description">{{ option.description }}</span>
                  </div>
                  <span class="option-price">{{ option.price | price }}</span>
               </li>
            </ul>
         </div>
      </div>

      <!-- SSR Notes -->
      <ul class="checkout-ssr-notes" v-if="ssrNotes.length">
         <li v-for="(note, index) in ssrNotes" :key="index" :class="{ 'is-mandatory': note.isMandatory }">
            <template v-if="note.label">
               <strong v-if="false">{{ note.label }}:</strong> {{ note.text }}
            </template>
            <template v-else>{{ note.text }}</template>
         </li>
      </ul>

      <!-- Update Basket Button -->
      <div class="update-basket-wrapper">
         <UIButton className="gradient_blue_pink" :text="$t('CheckoutSSRs_btnUpdateBasket')" @click.native="handlerUpdateBasket" :disabled="isMandatoryMissing" />
      </div>
   </div>
</template>

<script>
import checkoutSSRsMixin from "@/mixins/checkoutSSRsMixin";
import UIButton from "@/components/unitary/Button.vue";

export default {
   name: "CheckoutSsr",
   mixins: [checkoutSSRsMixin],
   components: {
      UIButton,
   },
   props: {
      data: Object,
      flightIdentifier: String,
   },

   data() {
      return {
         currentIndex: 0,
         maxVisibleItems: 4,
         isInitialLoad: true,
         showSegmentBreakdown: true,
         activeDropdown: null, // { paxIndex, segmentIndex, colIndex, columnId, options, ssr }
         dropdownPosition: { top: 0, left: 0 },
      };
   },

   mounted() {
      // İlk yüklemede carousel animasyonu göster
      if (this.showCarousel && this.totalItems > this.maxVisibleItems) {
         // Son indexe git
         this.currentIndex = Math.max(0, this.totalItems - this.maxVisibleItems);

         // 800ms sonra başa dön
         setTimeout(() => {
            this.currentIndex = 0;
            this.isInitialLoad = false;
         }, 800);
      } else {
         this.isInitialLoad = false;
      }

      // Event listeners
      window.addEventListener("resize", this.closeDropdown);
      window.addEventListener("scroll", this.closeDropdown, true);
   },

   beforeDestroy() {
      window.removeEventListener("resize", this.closeDropdown);
      window.removeEventListener("scroll", this.closeDropdown, true);
   },

   watch: {
      currentIndex() {
         // Carousel scroll olduğunda dropdown'ı kapat
         this.closeDropdown();
      },
   },

   computed: {
      totalItems() {
         return this.SSRs.columns ? this.SSRs.columns.length : 0;
      },
      visibleColumns() {
         if (!this.SSRs.columns) return [];
         return this.SSRs.columns.slice(this.currentIndex, this.currentIndex + this.maxVisibleItems);
      },
      canScrollLeft() {
         return this.currentIndex > 0;
      },
      canScrollRight() {
         return this.currentIndex + this.maxVisibleItems < this.totalItems;
      },
      showCarousel() {
         return this.totalItems > this.maxVisibleItems;
      },
      translateX() {
         if (!this.SSRs.columns) return 0;
         let offset = 0;
         for (let i = 0; i < this.currentIndex; i++) {
            const columnWidth = this.SSRs.columns[i].identifier === "meal" ? 216 : 162;
            offset += columnWidth;
         }
         return offset;
      },
      wrapperWidth() {
         if (!this.SSRs.columns) return "auto";
         const visibleCount = Math.min(this.maxVisibleItems, this.totalItems);
         let totalWidth = 0;

         // Görünen kolonların genişliğini hesapla
         for (let i = this.currentIndex; i < this.currentIndex + visibleCount; i++) {
            const col = this.SSRs.columns[i];
            const columnWidth = col?.identifier === "meal" ? 216 : 162;
            totalWidth += columnWidth;
         }

         return `${totalWidth}px`;
      },
   },

   methods: {
      scrollLeft() {
         if (this.canScrollLeft) {
            this.currentIndex--;
         }
      },
      scrollRight() {
         if (this.canScrollRight) {
            this.currentIndex++;
         }
      },
      openDropdown(event, paxIndex, segmentIndex, colIndex, columnId, options, ssr) {
         // Dropdown zaten açıksa kapat
         if (this.activeDropdown && this.activeDropdown.paxIndex === paxIndex && this.activeDropdown.segmentIndex === segmentIndex && this.activeDropdown.colIndex === colIndex) {
            this.closeDropdown();
            return;
         }

         // Önce pozisyonu hesapla (dropdown açılmadan önce)
         const triggerElement = event.currentTarget;
         const triggerRect = triggerElement.getBoundingClientRect();

         // Dropdown'ın parent container'ını bul (.checkout-ssrs-carousel)
         const carouselElement = this.$el.querySelector(".checkout-ssrs-carousel");
         if (!carouselElement) return;

         const carouselRect = carouselElement.getBoundingClientRect();

         // Son yolcu mu kontrol et (dropdown yukarı açılsın mı)
         const isLastPassenger = paxIndex === this.SSRs.paxes.length - 1;

         // Sağ/sol kenar kontrolü
         const dropdownWidth = 296;
         const viewportWidth = window.innerWidth;

         // Trigger button'ın merkezine göre dropdown'ı hizala
         const triggerCenter = triggerRect.left + triggerRect.width / 2;
         let left = triggerCenter - carouselRect.left - dropdownWidth / 2;
         let top = triggerRect.bottom - carouselRect.top + 6;

         // Dropdown yukarı açılmalı mı?
         if (isLastPassenger) {
            top = triggerRect.top - carouselRect.top;
         }

         // Sağ kenara çok yakınsa sola kaydır
         if (triggerRect.left + dropdownWidth > viewportWidth - 20) {
            left = triggerRect.right - dropdownWidth - carouselRect.left;
         }

         // Sol kenara çok yakınsa saga kaydır
         if (left < 0) {
            left = triggerRect.left - carouselRect.left;
         }

         // Pozisyonu set et
         this.dropdownPosition = { top, left };

         // Sonra dropdown'ı aç (pozisyon hazır olacak)
         this.activeDropdown = {
            paxIndex,
            segmentIndex,
            colIndex,
            columnId,
            options,
            ssr,
         };
      },
      closeDropdown() {
         this.activeDropdown = null;
      },
      selectSSRFromGlobalDropdown(option) {
         const { paxIndex, segmentIndex, columnId, ssr } = this.activeDropdown;
         this.selectSSR(ssr, option, columnId, this.SSRs.paxes[paxIndex].id, segmentIndex + 1, this.flightIdentifier);
         this.closeDropdown();
      },
   },
};
</script>

<style>
.dark-theme .column-header .dark-mode-ssr-image {
   display: block !important;
   mix-blend-mode: normal !important;
}

.dark-theme .column-header .light-mode-ssr-image,
.light-theme .column-header .dark-mode-ssr-image {
   display: none !important;
}

.light-theme .column-header .light-mode-ssr-image {
   mix-blend-mode: multiply !important;
}

.dark-theme .pax-footer-space {
   background-color: #161616 !important;
}

.dark-theme .ssr-add {
   background-color: var(--gray-0) !important;
}

.dark-theme .ssr-name {
   color: var(--blue-300) !important;
}

.dark-theme .ssr-price,
.dark-theme .ssr-free-label {
   color: var(--blue-400) !important;
}

.dark-theme .in-basket .ssr-name {
   color: var(--green-300) !important;
}

.dark-theme .in-basket .ssr-price,
.dark-theme .in-basket .ssr-free-label {
   color: var(--green-400) !important;
}
</style>

<style lang="scss" scoped>
@mixin conjuncted-pip($bg-color) {
   &::before,
   &::after {
      content: "";
      position: absolute;
      top: -14px;
      display: block;
      width: 16px;
      height: 14px;
      background-color: $bg-color;
   }

   &::before {
      transform: translateX(-16px);
   }

   &::after {
      transform: translateX(16px);
   }
}

.checkout-ssrs-container {
   display: flex;
   // gap: 1rem;
   width: 100%;
}

.checkout-ssr-paxes-wrapper {
   display: flex;
   flex-direction: column;
   min-width: 260px;

   @media (max-width: 768px) {
      min-width: 120px;
   }
}

.pax-header-space {
   height: 170px;
}

.pax-info-body {
   flex: 1;
   border: 1.5px solid var(--gray-200);
   border-radius: 0.5rem;
   border-top-right-radius: 0;
   border-bottom-right-radius: 0;
   border-bottom-left-radius: 0;
   background-color: var(--gray-0);
}

.pax-info-cell {
   display: flex;
   min-height: 80px;
   border-bottom: 2px dashed var(--gray-200);

   &:last-child {
      border-bottom: none;
   }
}

.passenger-info {
   display: flex;
   flex-direction: column;
   padding: 0.5rem 1rem;
   width: 120px;
   justify-content: flex-start;
   padding-top: 1.5rem;

   @media (max-width: 768px) {
      width: 60px;
      padding: 0.5rem 0.5rem;
   }

   .passenger-name {
      font-size: 16px;
      font-weight: 600;
      line-height: 1.2rem;
      white-space: nowrap;

      @media (max-width: 768px) {
         font-size: 12px;
      }
   }

   .passenger-type {
      font-size: 14px;
      line-height: 1.2rem;
      white-space: nowrap;

      @media (max-width: 768px) {
         font-size: 10px;
      }
   }
}

.segments {
   display: flex;
   flex-direction: column;
   flex: 1;
}

.segment-route {
   display: flex;
   align-items: flex-start;
   gap: 0.5rem;
   padding: 0.5rem;
   padding-top: 1.5rem;
   height: 120px;
   box-sizing: border-box;

   @media (max-width: 768px) {
      padding: 0.25rem;
      gap: 0.25rem;
   }

   .route-from,
   .route-to {
      font-size: 16px;
      font-weight: 500;
      min-width: 40px;

      @media (max-width: 768px) {
         font-size: 11px;
         min-width: 25px;
      }
   }

   .route-airline {
      width: 24px;
      height: 24px;

      @media (max-width: 768px) {
         display: none;
      }
   }
}

.pax-footer-space {
   display: flex;
   align-items: flex-start;
   padding: 0;
   font-weight: 600;
   font-size: 16px;
   color: var(--gray-700);
   // background: linear-gradient(90deg, rgba(40, 135, 210, 0.125) 0%, rgba(146, 90, 222, 0.125) 100%);
   background-color: #e2e5fb;
   border-bottom-left-radius: 1rem;
   border-bottom-right-radius: 1rem;
   border: 1.5px solid var(--gray-200);
   border-top: none;
   min-height: 60px;

   .total-label-wrapper {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      width: 120px;
      padding: 0.5rem 1rem;
      padding-top: 1rem;

      i {
         cursor: pointer;
         font-size: 18px;
         transition: color 0.2s ease;

         &:hover {
            color: var(--blue-600);
         }
      }
   }

   .segment-routes {
      display: flex;
      flex-direction: column;
      flex: 1;
      // padding-top: 1rem;

      .segment-route-item {
         display: flex;
         align-items: center;
         gap: 0.5rem;
         padding: 0.5rem;
         height: 36px;
         box-sizing: border-box;

         .route-from,
         .route-to {
            font-size: 16px;
            font-weight: 600;
            min-width: 40px;
         }

         .route-airline {
            width: 24px;
            height: 24px;
         }
      }
   }
}

.checkout-ssrs-carousel {
   display: flex;
   align-items: center;
   // gap: 10px;
   flex: 1;
   position: relative;
}

.nav-arrow {
   position: absolute;
   width: 30px;
   height: 50px;
   background: var(--blue-600);
   outline: 4px solid var(--blue-100);
   color: white;
   border: none;
   border-radius: 0.5rem;
   font-size: 32px;
   cursor: pointer;
   display: flex;
   align-items: center;
   justify-content: center;
   z-index: 10;
   margin-top: 130px;
   animation: arrowPulse 0.5s ease-in-out 4;

   @keyframes arrowPulse {
      0%,
      100% {
         transform: scale(1);
      }
      50% {
         transform: scale(1.2);
      }
   }

   i {
      filter: brightness(10);
   }

   &:hover:not(:disabled) {
      background: #0056b3;
   }

   &:disabled {
      background: #ccc;
      cursor: not-allowed;
      opacity: 0;
      animation: none;

      i {
         filter: brightness(10);
      }
   }

   &.nav-right {
      right: -35px;
   }
   &.nav-left {
      left: -15px;
   }
}

.columns-wrapper {
   overflow-x: hidden;
   overflow-y: visible;
   // width dinamik olarak computed property'den geliyor
}

.columns-container {
   display: flex;
   transition: transform 0.3s ease;
}

.ssr-column {
   display: flex;
   flex-direction: column;
   width: 162px;
   flex-shrink: 0;

   &.meal {
      width: 216px;
   }
}

.column-header {
   height: 170px;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   font-weight: bold;
   gap: 8px;
   border-top-left-radius: 1rem;
   border-top-right-radius: 1rem;
   border: 1.5px solid var(--gray-200);
   box-sizing: border-box;
   position: relative;
   overflow: hidden;

   img {
      &.checkin_priority {
         margin-top: -20px;
         transform: scale(0.85);
         transform-origin: top;
      }
   }
   &.is-odd {
      background-color: var(--gray-100);
   }

   &.is-even {
      background-color: var(--gray-0);
   }

   .light-mode-ssr-image {
      max-width: 180px;
      max-height: 120px;
      transition: opacity 0.2s ease;
      mix-blend-mode: multiply;
   }

   .dark-mode-ssr-image {
      max-width: 180px;
      max-height: 120px;
      transition: opacity 0.2s ease;
      display: none;
   }

   .ssr-header-remove {
      display: none;
      width: 36px;
      height: 36px;
      background-color: var(--red-600);
      border-radius: 50%;
      position: relative;

      &::before,
      &::after {
         content: "";
         position: absolute;
         top: 50%;
         left: 50%;
         background-color: #fff;
         border-radius: 1px;
      }

      &::before {
         width: 16px;
         height: 2px;
         transform: translate(-50%, -50%) rotate(-45deg);
      }

      &::after {
         width: 2px;
         height: 16px;
         transform: translate(-50%, -50%) rotate(-45deg);
      }
   }

   .ssr-header-name {
      position: absolute;
      bottom: 0.25rem;
      font-weight: 500;
      transition: opacity 0.2s ease;
      text-align: center;
      padding: 0 1rem;
      line-height: 1rem;
      font-size: 16px;
   }

   &.hover-remove {
      background-color: #fde8e8;
      cursor: pointer;

      img {
         display: none;
      }

      .ssr-header-remove {
         display: block;
      }

      .ssr-header-name {
         display: none;
      }
   }
}

.column-body {
   flex: 1;
}

.pax-cell {
   display: flex;
   flex-direction: column;
   border-bottom: 2px dashed var(--gray-200);
   border-right: 1.5px solid var(--gray-200);
   border-left: 1.5px solid var(--gray-200);

   &:last-child {
      border-bottom: none;
   }
}

.segment-cell {
   height: 120px;
   display: flex;
   align-items: center;
   justify-content: center;
   box-sizing: border-box;
}

.ssr-item {
   width: 100%;
   display: flex;
   justify-content: center;
   align-items: center;
}

.ssr-button {
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
   width: 146px;
   min-height: 108px;
   border-radius: 1rem;
   background-color: var(--gray-100);
   border: none;
   cursor: pointer;
   line-height: 1.25rem;
   font-weight: 600;
   position: relative;

   &.btn-disabled {
      cursor: not-allowed;
   }

   &.is-conjucted {
      @include conjuncted-pip(var(--gray-100));
   }

   &.is-mandatory {
      border: 2px dashed var(--orange-200);
      background-color: color-mix(in srgb, var(--orange-100) 20%, white);

      .ssr-add {
         background-color: var(--orange-400);
      }
   }

   &.making-selection {
      background-color: var(--blue-100) !important;

      .ssr-add {
         background-color: var(--blue-600);
      }
   }

   &.has-selection {
      background-color: var(--blue-100);
      color: var(--blue-700);
      animation: ssrSelected 0.3s ease;

      &::before,
      &::after {
         background-color: var(--blue-100);
      }

      @keyframes ssrSelected {
         0% {
            transform: scale(0.95);
            opacity: 0.5;
         }
         50% {
            transform: scale(1.05);
         }
         100% {
            transform: scale(1);
            opacity: 1;
         }
      }

      .ssr-name,
      .ssr-price {
         animation: fadeIn 0.3s ease;
      }

      @keyframes fadeIn {
         from {
            opacity: 0;
            transform: translateY(-5px);
         }
         to {
            opacity: 1;
            transform: translateY(0);
         }
      }

      &.in-basket {
         background-color: var(--green-100);
         color: var(--green-700);

         &::before,
         &::after {
            background-color: var(--green-100);
         }

         .ssr-name {
            color: var(--green-700);
         }

         .ssr-price {
            color: var(--green-800);
         }

         .ssr-free-label {
            color: var(--green-800);
         }

         &:hover {
            background-color: #fde8e8;
            color: var(--red-700);

            &::before,
            &::after {
               background-color: #fde8e8;
            }

            .ssr-name,
            .ssr-price {
               opacity: 0;
            }

            .ssr-close {
               opacity: 1;
            }
         }
      }

      &.free-conjuncted {
         @include conjuncted-pip(var(--blue-100));
         cursor: not-allowed;

         &.in-basket {
            @include conjuncted-pip(var(--green-100));
         }

         &.remove-preview {
            background-color: #fde8e8;
            color: var(--red-700);
            @include conjuncted-pip(#fde8e8);

            .ssr-name,
            .ssr-price,
            .ssr-free-label {
               opacity: 1;
               color: var(--red-700);
            }
         }
      }

      &:hover {
         background-color: #fde8e8;
         color: var(--red-700);

         .ssr-name,
         .ssr-price {
            opacity: 0;
         }

         .ssr-close {
            opacity: 1;
         }
      }
   }

   .ssr-add,
   .ssr-close {
      width: 32px;
      height: 32px;
      background-color: var(--blue-400);
      border-radius: 50%;
      position: relative;

      &::before,
      &::after {
         content: "";
         position: absolute;
         top: 50%;
         left: 50%;
         background-color: #fff;
         border-radius: 1px;
      }

      &::before {
         width: 14px;
         height: 2px;
         transform: translate(-50%, -50%);
      }

      &::after {
         width: 2px;
         height: 14px;
         transform: translate(-50%, -50%);
      }
   }

   .ssr-close {
      opacity: 0;
      position: absolute;
      top: 50%;
      left: 50%;
      background-color: var(--red-600);
      transform: translate(-50%, -50%);

      &::before {
         transform: translate(-50%, -50%) rotate(-45deg);
      }

      &::after {
         transform: translate(-50%, -50%) rotate(-45deg);
      }
   }

   .ssr-name {
      font-size: 14px;
      font-weight: 600;
      line-height: 1rem;
      transition: opacity 0.2s ease;
   }

   .ssr-price {
      font-size: 16px;
      font-weight: 900;
      color: var(--blue-800);
      transition: opacity 0.2s ease;
   }

   .ssr-mandatory-label {
      font-size: var(--xsmall);
      font-weight: 600;
      color: var(--orange-500);
      margin-top: 4px;
   }

   .ssr-free-label {
      font-size: 14px;
      font-weight: 900;
      color: var(--blue-800);
   }
}

.ssr-dropdown {
   background: var(--gray-0);
   border: 1.5px solid var(--gray-200);
   border-radius: 0.75rem;
   box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
   min-width: 296px;
   z-index: 100;
   max-height: 300px;
   overflow-y: auto;

   &.ssr-dropdown-global {
      position: absolute;

      &:not(.dropdown-up) {
         animation: dropdownFadeInDown 0.15s ease;
      }

      &.dropdown-up {
         transform: translateY(-100%);
         animation: dropdownFadeInUp 0.15s ease;
      }

      @keyframes dropdownFadeInDown {
         from {
            opacity: 0;
            transform: translateY(-8px);
         }
         to {
            opacity: 1;
            transform: translateY(0);
         }
      }

      @keyframes dropdownFadeInUp {
         from {
            opacity: 0;
            transform: translateY(-100%) translateY(8px);
         }
         to {
            opacity: 1;
            transform: translateY(-100%);
         }
      }
   }

   li {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 0.25rem 0.75rem;
      cursor: pointer;
      transition: background-color 0.15s ease;
      border-bottom: 1.5px solid var(--gray-200);

      &:hover {
         background-color: var(--blue-50);
      }

      .option-description {
         font-weight: 500;
         font-size: 16px;
         max-width: 150px;
      }

      .option-price {
         font-size: 16px;
         color: var(--gray-600);
         font-weight: 600;
         margin-right: 0.5rem;
      }
   }
}

.column-footer {
   min-height: 60px;
   display: flex;
   align-items: center;
   justify-content: center;
   font-weight: 600;
   padding: 0.5rem;
   border-right: 1.5px solid var(--gray-200);
   border-left: 1.5px solid var(--gray-200);
   border-bottom: 1.5px solid var(--gray-200);
   background: linear-gradient(90deg, rgba(40, 135, 210, 0.125) 0%, rgba(146, 90, 222, 0.125) 100%);
   border-bottom-left-radius: 1rem;
   border-bottom-right-radius: 1rem;

   .segment-breakdown {
      display: flex;
      flex-direction: column;
      width: 100%;
      // padding-top: 1rem;

      .segment-total {
         display: flex;
         align-items: center;
         justify-content: center;
         height: 28px;
         box-sizing: border-box;

         .total-price {
            font-size: 16px;
         }

         .total-empty {
            min-height: 20px;
         }
      }
   }

   .total-price {
      font-size: 18px;
      font-weight: 800;
      color: var(--gray-700);
   }

   .total-empty {
      min-height: 28px;
      color: var(--gray-400);
   }
}

.checkout-ssr-notes {
   display: flex;
   flex-direction: column;
   background-color: var(--yellow-100);
   border: 1.5px solid var(--yellow-300);
   padding: 0.5rem 1rem;
   border-radius: 1rem;
   width: 100%;
   margin-top: 0.5rem;
   margin-bottom: 0.5rem;

   li {
      font-size: var(--small);
      strong {
         font-weight: 500;
      }

      &.is-mandatory {
         font-weight: 700;
         max-width: 750px;
      }
   }
}

.update-basket-wrapper {
   display: flex;
   justify-content: center;
   width: 100%;
   margin-top: 1rem;
}
</style>
